import { Typography } from "@material-ui/core";

const NotFound = () => (
  <Typography variant="h2" align="center">
    The page you are looking for cannot be found 😫
  </Typography>
);

export default NotFound;
